import { preferencesActionTypes } from './preferences.types';

// FETCH
export const preferencesFetchRequest = () => ({
    type: preferencesActionTypes.PREFERENCES_FETCH_REQUEST,
});
export const preferencesFetchSuccess = (preferences) => ({
    type: preferencesActionTypes.PREFERENCES_FETCH_SUCCESS,
    payload: preferences,
});
export const preferencesFetchFailure = (error) => ({
    type: preferencesActionTypes.PREFERENCES_FETCH_FAILURE,
    payload: error,
});

// PATCH
// `partial` is a partial Preferences object, e.g. { theme: 'dark' } or { sidebar_collapsed: true }
export const preferencesPatchRequest = (partial) => ({
    type: preferencesActionTypes.PREFERENCES_PATCH_REQUEST,
    payload: partial,
});
export const preferencesPatchSuccess = (preferences) => ({
    type: preferencesActionTypes.PREFERENCES_PATCH_SUCCESS,
    payload: preferences,
});
export const preferencesPatchFailure = (error) => ({
    type: preferencesActionTypes.PREFERENCES_PATCH_FAILURE,
    payload: error,
});
// `previous` is the slice values that were optimistically replaced — used to revert.
export const preferencesPatchRevert = (previous) => ({
    type: preferencesActionTypes.PREFERENCES_PATCH_REVERT,
    payload: previous,
});

// SYSTEM THEME (matchMedia)
export const systemThemeChanged = (systemIsDark) => ({
    type: preferencesActionTypes.SYSTEM_THEME_CHANGED,
    payload: systemIsDark,
});

// RESET
export const preferencesReset = () => ({
    type: preferencesActionTypes.PREFERENCES_RESET,
});
